var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var PrescriptionItem = /** @class */ (function (_super) {
    __extends(PrescriptionItem, _super);
    function PrescriptionItem(name, description) {
        var _this = _super.call(this) || this;
        name && _this.setMedicineName(name);
        description && _this.setDescription(description);
        return _this;
    }
    PrescriptionItem.prototype.getId = function () {
        return Number(this.id);
    };
    PrescriptionItem.prototype.getMedicineName = function () {
        return this.medicine_name;
    };
    PrescriptionItem.prototype.setMedicineName = function (name) {
        this.medicine_name = name;
    };
    PrescriptionItem.prototype.getDescription = function () {
        return this.description;
    };
    PrescriptionItem.prototype.setDescription = function (description) {
        this.description = description;
    };
    return PrescriptionItem;
}(Model));
export default PrescriptionItem;
